import api from "../../services/api";

const useUsers = (filialId) => {
    const findAll = async () => {
        const { data } = await api.get(`/usersTransf/${filialId}`);
        return data;
    }

    return { findAll };
};

export default useUsers;
